import { Link } from '@tanstack/react-router'
import { Home } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'

export function NotFound() {
  const { t } = useTranslation()
  return (
    <div className="grid min-h-[60vh] place-items-center p-8">
      <div className="text-center">
        <p className="text-xs font-medium uppercase tracking-wider text-primary">
          404
        </p>
        <h1 className="mt-2 text-2xl font-semibold tracking-tight">
          {t('common.notFoundTitle')}
        </h1>
        <p className="mt-2 max-w-sm text-sm text-muted-foreground">
          {t('common.notFoundBody')}
        </p>
        <div className="mt-5">
          <Button asChild>
            <Link to="/">
              <Home className="mr-1.5 h-4 w-4" />
              {t('common.backHome')}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
